import {
  Anchor as MantineAnchor,
  AnchorProps as MantineAnchorProps,
  PolymorphicComponentProps,
} from "@mantine/core"
import { forwardRef } from "react"

export type AnchorProps = PolymorphicComponentProps<"a", MantineAnchorProps> & {
  children?: React.ReactNode
}

export const Anchor = forwardRef<HTMLAnchorElement, AnchorProps>(
  ({ children, ...props }, ref) => {
    return (
      <MantineAnchor ref={ref} {...props}>
        {children}
      </MantineAnchor>
    )
  }
)
